'use strict';

const Modal = require('../../modules/ui/modal');
const trackingUtils = require('../utils/tracking.utils');
const FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES = 'flexibility_disruption';
const FLEX_MODAL_WHEN_SELECTOR = '.flex_when_option';
const FLEX_MODAL_WHAT_SELECTOR = '.flex_what_option';
const FLEX_MODAL_HOW_SELECTOR = '.flex_how_option';
const ACK_TRACKING_LABEL = 'ok';
const KNOW_MORE_TRACKING_LABEL = 'more';
const CLOSE_TRACKING_LABEL = 'close';

module.exports = Backbone.View.extend({
    initialize(options) {
        this.template = options.template;
        this.templateData = options.translations;
        this.page = options.page;
        this.initModal();
        this.trackOnload();
    },
    events: {
        'tap .close_icon': 'onCloseClick',
        'tap .ack_button': 'onAckClick',
        'tap .know_more_button': 'onKnowMoreClick',
    },

    initModal() {
        Odigeo.Templates.getGenericTemplates([FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES])
            .then(Odigeo._.bind(function(templates) {
                if (Odigeo._.isObject(templates)) {
                    const flexibilityDisruptionTemplates = Odigeo._.get(templates, FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES);
                    const flexibilityDisruptionTemplatesKeys = templates.getStaticTemplatesKeys(FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES);
                    const modalTemplateBuilter = Odigeo._.get(flexibilityDisruptionTemplates, 'modals/modal', Odigeo._.noop);
                    const modalContentTemplateBuilder = Odigeo._.get(flexibilityDisruptionTemplates, 'modals/content', Odigeo._.noop);

                    const $modalContainer = $('.flexibility_disruption_popup');
                    const getFlexibilityDisruptionDesktop = Odigeo.AB.getFlexibilityDisruptionDesktop;
                    const isFlexibilityDisruptionDesktop = getFlexibilityDisruptionDesktop >= 3;
                    let bgImageClass;
                    if (isFlexibilityDisruptionDesktop) {
                        bgImageClass = getFlexibilityDisruptionDesktop === 3 ? 'od-flex-bg-c' : 'od-flex-bg-d';
                    }
                    this.modal = new Modal($modalContainer, {
                        content: modalContentTemplateBuilder(Odigeo._.extend(flexibilityDisruptionTemplatesKeys, {bgImageClass})),
                        button: Odigeo._.get(flexibilityDisruptionTemplatesKeys, 'flexibilityDisruptionPopUpCloseButton', ''),
                    },
                    {
                        template: modalTemplateBuilter,
                        fillThePage: false,
                        preventContainerTap: false,
                        open: {
                            analytics: {
                                action: 'free-cancellation_onload-nag',
                                label: 'free-cancellation_onload-nag_pag:' + this.page,
                            },
                        },
                        close: {
                            analytics: {
                                action: 'free-cancellation_onload-nag',
                                label: 'free-cancellation_close-nag_pag:' + this.page,
                            },
                        },
                        button: {
                            analytics: {
                                action: 'free-cancellation_onload-nag',
                                label: 'free-cancellation_close-info_pag:' + this.page,
                            },
                        },
                    });
                    $modalContainer.find(FLEX_MODAL_WHEN_SELECTOR).on('click', Odigeo._.bind(this.trackWhenOnClick, this));
                    $modalContainer.find(FLEX_MODAL_WHAT_SELECTOR).on('click', Odigeo._.bind(this.trackWhatOnClick, this));
                    $modalContainer.find(FLEX_MODAL_HOW_SELECTOR).on('click', Odigeo._.bind(this.trackHowOnClick, this));
                    $modalContainer.removeClass('odf-hidden');
                    this.render();
                }
            }, this));
    },

    render() {
        this.$el.html(this.template(this.templateData));
    },

    trackWhenOnClick() {
        trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_when_pag:' + this.page);
    },

    trackWhatOnClick() {
        trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_what_pag:' + this.page);
    },

    trackHowOnClick() {
        trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_how_pag:' + this.page);
    },

    trackOnload() {
        trackingUtils.trackEvent('free-cancellation_onload-popup', 'free-cancellation_onload-popup_pag:' + this.page);
    },

    trackOnclick(buttonLabel) {
        trackingUtils.trackEvent('free-cancellation_popup', 'free-cancellation_' + buttonLabel + '-popup_pag:' + this.page);
    },

    onKnowMoreClick() {
        this.trackOnclick(KNOW_MORE_TRACKING_LABEL);
        this.modal.then((flexAlertsModal) => {
            flexAlertsModal.open(true, true);
        });
        this.hide();
    },

    onAckClick() {
        this.trackOnclick(ACK_TRACKING_LABEL);
        this.hide();
    },

    onCloseClick() {
        this.trackOnclick(CLOSE_TRACKING_LABEL);
        this.hide();
    },

    hide() {
        this.$el.addClass('odf-hidden');
        Odigeo.Session.set('FlexSystemAlertClosed', true);
    },
});
